import {
  __async
} from "./chunk--chunk-RQ7252KT.js";

// src/js/components/Search.js
var Search = class {
  constructor(el) {
    this.el = el;
    this.input = el.querySelector("input");
    this.resultsContainer = el.querySelector("[data-results-container]");
    this.toggle = el.querySelector("[data-toggle]");
    this.modal = el.querySelector("[data-modal]");
    this.close = el.querySelector("[data-close]");
  }
  init() {
    this.input.addEventListener("input", (e) => {
      const term = e.target.value.trim();
      if (!term.length) {
        this.resultsContainer.innerHTML = "";
        return;
      }
      this.getResults();
    });
    if (this.toggle)
      this.toggle.addEventListener("click", () => this.openModal());
    if (this.close)
      this.close.addEventListener("click", () => this.closeModal());
  }
  openModal() {
    this.modal.classList.add("active");
  }
  closeModal() {
    this.input.value = "";
    this.resultsContainer.innerHTML = "";
    this.modal.classList.remove("active");
  }
  getResults() {
    setTimeout(() => __async(this, null, function* () {
      if (this.input.value === "") {
        this.resultsContainer.innerHTML = "";
      } else {
        try {
          const res = yield fetch(
            `/search/suggest?q=${this.input.value}&resources[type]=query,product&resources[options][unavailable_products]=hide&resources[options][fields]=title&section_id=predictive-search`
          );
          const text = yield res.text();
          this.resultsContainer.innerHTML = text;
          this.resultsContainer.querySelectorAll("[data-query]").forEach((button) => {
            const query = button.getAttribute("data-query");
            button.addEventListener("click", () => {
              this.input.value = query;
              this.getResults(query);
            });
          });
        } catch (err) {
          console.error(err);
        }
      }
    }), 500);
  }
};
var Search_default = Search;
export {
  Search_default as default
};
